<template>
	<div>
		<div v-html="alipayInfo"></div>
	</div>
</template>

<script>
	export default {
		name: 'Alipay',
		data() {
			return {
				alipayInfo: ''
			}
		},
		methods: {
			toPay(data) {
				this.$http.post(userSelfUrl + '/pay', data).then((res) => {
					if(res.data.ecode == ResEcode) {
						// 得到的支付宝的完整支付页面字符串
						this.alipayInfo = res.data.data
					} else {
						this.responseText = '提示：' + res.data.msg
					}
				})
			},
		},
		props: {
			html: String,
		},
		created() {

			const div = document.createElement('div');
			div.innerHTML = this.html;
			document.body.appendChild(div);
			document.forms[0].submit();
		},
		updated() {
			//    document.forms[0].submit()
		}
	}
</script>

<style>

</style>